import { environment } from '@prcins/environments';

export const LOGIN_URL = {
  Authenticate: `${environment.BASE_URL}/account/authenticate`,
  AuditUrl: `${environment.BASE_URL}/account/audit/electronicconsent`
}
